<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" @click="addRecharge()">充值</el-button>
      <el-input v-model="searchName" prefix-icon="el-icon-search" placeholder="输入姓名" style="width: 250px"></el-input>
      <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="daterange" unlink-panels
                      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd" style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-button type="success" @click="searchBtn">查询</el-button>
    </div>
    <div style="max-height: calc(100% - 120px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="elderly_name"
          label="老人姓名"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          label="变动类型"
          width="90"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.change_type === 1">充值</span>
            <span v-if="scope.row.change_type === 2">消费</span>
            <span v-if="scope.row.change_type === 3">退款</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="change_amount"
          label="变动金额"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="before_amount"
          label="变动前余额"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="after_amount"
          label="变动后余额"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="change_time"
          label="变动时间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="change_remark"
          label="变动备注"
          min-width="100"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{addEditTitle}}</span>
        <div class="line-title"></div>
      </div>
      <finance-order :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></finance-order>
    </el-dialog>
  </div>
</template>

<script>
import {queryelderlyfinanceorder} from '../../api/yanglaoyuan'
import financeOrder from './components/financeOrder'
import {queryorg} from '../../api/organizer'
export default {
  name: 'rechargePay',
  components: {financeOrder},
  data () {
    return {
      searchName: '',
      sendDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      entityId: 0,
      addEditShow: false,
      addEditTitle: '',
      addEditObj: {
        isAdd: true,
        change_type: 1, // 1、充值
        row: '',
        orgArr1: [],
        orgArr2: []
      },
      orgArr: []
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-7)
    this.sendDate = [start.format('yyyy-MM-dd'), end]
    this.getTimeObj()
    this.getOrgData()
    this.queryDataTable()
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 12; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + '-' + arr[1] + '-' + '01'
        obj.end = arr[0] + '-' + arr[1] + '-' + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    // 组织
    getOrgData () {
      this.addEditObj.orgArr1 = []
      this.addEditObj.orgArr2 = []
      queryorg().then(res => {
        this.orgArr = this.clone(res.data.org)
        for (let i = 0; i < this.orgArr.length; i++) {
          if (this.orgArr[i].org_type === 1) {
            this.addEditObj.orgArr1.push(this.orgArr[i])
          }
          if (this.orgArr[i].org_type === 2) {
            this.addEditObj.orgArr2.push(this.orgArr[i])
          }
        }
      }).catch(() => {
      })
    },
    queryDataTable () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.entityId,
        epid: 0,
        ep_name: this.searchName,
        change_time_from: this.sendDate[0] + ' 00:00:00',
        change_time_to: this.sendDate[1] + ' 23:59:59'
      }
      queryelderlyfinanceorder(params, data).then(res => {
        this.tableData = res.data.elderlyFinanceOrder
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    searchBtn () {
      this.queryDataTable()
    },
    updateTable () {
      this.queryDataTable()
    },
    addRecharge () {
      this.addEditTitle = '充值'
      this.addEditObj.change_type = 1
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/rechargePay.vue